import Component from '../abstracts/Component';

export default class CarouselComponent extends Component {

  get SELECTORS() {
    return {
      main: '[data-carousel="true"]',
      lookBookCurrent: '.js-lookbook-current-slide',
      currentNumberedSlide: '.js-current-number-slide'
    };
  }


  constructor() {
    super();
    this.main = $(this.SELECTORS.main);
    this.whatchRes = [];
  }

  importLibrary() {

    this.moduleLoader.loadCarouselAndExecute(
      (module) => {
        this.initCarousels();
        this.bindEvents();
      },
      (error) => {
        console.error("failed to load slick ", error.stack);
      }
    )
  }

  initLookbookCarousel(carousel) {
    $(carousel).slick({
      dots: true,
      mobileFirst: true,
      arrows: false,
      infinite: false,
      accessibility: false,
      swipeToSlide: true,
      slidesToShow: 2.02,
      slidesToScroll: 1,
      responsive: [
	  {
        breakpoint: 767,
        settings: {
          slidesToShow: 4.01
        },
      },
      {
        breakpoint: 1279,
        settings: {
          arrows: true,
          slidesToShow: 4
        }
      }]
    });

    $(carousel).on('afterChange', (e, slick, currentSlide) => {
      let visibleMarkers = document.querySelectorAll('.js-lookbook-image.markers-visible');
      visibleMarkers.forEach( visibleMarker => {
        let activeMarker = visibleMarker.querySelector('.js-marker')
        activeMarker.click();
      });
    });
  }

  initCarousels() {

    let carousels = document.querySelectorAll(this.SELECTORS.main);

    carousels.forEach(carousel => {
      const maxRes = carousel.dataset.carouselMaxres ? carousel.dataset.carouselMaxres : false;
      const matchMedia = maxRes ? this.$matchMedia(carousel.dataset.carouselMaxres, null) : false;
      if (maxRes && matchMedia || !maxRes && !matchMedia) {
        if (carousel.classList.contains('lookbook__carousel') && !carousel.classList.contains('slick-initialized')) {
          this.initLookbookCarousel(carousel);
        } else if (!carousel.classList.contains('slick-initialized') && !carousel.classList.contains('c-lookbook')) {
          $(carousel).slick();
        }
        if (carousel.dataset.carouselNumbered) {
          const numberCurrentSlide = carousel.parentElement.querySelector(this.SELECTORS.currentNumberedSlide);
          numberCurrentSlide.innerHTML = $(carousel).slick('slickCurrentSlide') + 1;
          $(carousel).on('afterChange', (e, slick, currentSlide) => {
            numberCurrentSlide.innerHTML = currentSlide + 1;
          })
        }
      } else if (maxRes && !matchMedia) {
        this.whatchRes.push(carousel);
      }

      if (carousel.dataset.carouselStart) {
        $(carousel).slick('slickGoTo', carousel.dataset.carouselStart - 1);
      }
    });
  }

  bindEvents() {
    this.$on('resize.carousel', () => {
      this.whatchRes.forEach(carousel => {
        const matchMedia = this.$matchMedia(carousel.dataset.carouselMaxres);
        const alreadyInit = carousel.classList.contains('slick-initialized');
        if (matchMedia && !alreadyInit) {
          if (carousel.classList.contains('lookbook-carousel')) {
            this.initLookbookCarousel(carousel);
          } else {
            $(carousel).slick();
          }
          if (carousel.dataset.carouselNumbered) {
            const numberCurrentSlide = document.querySelector(this.SELECTORS.currentNumberedSlide);
            numberCurrentSlide.innerHTML = $(carousel).slick('slickCurrentSlide') + 1;
            $(carousel).on('afterChange', (e, slick, currentSlide) => {
              numberCurrentSlide.innerHTML = currentSlide + 1;
            })
          }
        } else if (!matchMedia && alreadyInit) {
          $(carousel).slick('unslick');
        }
      });
    });
  }


  render() {
    if (document.querySelectorAll(this.SELECTORS.main)) this.importLibrary();

    this.$on(this.$customEvents.MODAL_EVENTS.afterOpen, () => {
      if ($('.vex').find('[data-carousel="true"]').length > 0) this.initCarousels();
    });

    this.$on(this.$customEvents.RETURN_EVENTS.subsituteProduct, () => {
      if (document.querySelectorAll(this.SELECTORS.main)) this.initCarousels();
    });

  }
}
